export default __webpack_public_path__ + "static/media/au_gray.71e5a553.svg";